export default __webpack_public_path__ + "static/media/url-shorteningImg_3.d5713496.png";